import { render, staticRenderFns } from "./LectureTopicSelector.vue?vue&type=template&id=392f0a7d"
import script from "./LectureTopicSelector.vue?vue&type=script&lang=js"
export * from "./LectureTopicSelector.vue?vue&type=script&lang=js"
import style0 from "./LectureTopicSelector.vue?vue&type=style&index=0&id=392f0a7d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports